import { render } from "./Dialog.vue?vue&type=template&id=5fd332f2&scoped=true"
import script from "./Dialog.vue?vue&type=script&lang=js"
export * from "./Dialog.vue?vue&type=script&lang=js"

import "./Dialog.vue?vue&type=style&index=0&id=5fd332f2&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-5fd332f2"

export default script